import { render, staticRenderFns } from "./TaxRollComments.vue?vue&type=template&id=1e3e4466&"
import script from "./TaxRollComments.vue?vue&type=script&lang=js&"
export * from "./TaxRollComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports